<template>
  <div class="points-container">
    <!-- 页面标题 -->
    <div class="header">
      <h2>健康档案人员积分分类</h2>
    </div>

    <!-- 操作按钮区域 -->
<!--    <div class="action-section">
      
    </div> -->

    <!-- 展开行控制 -->
    <div class="expand-control">
      <el-checkbox v-model="expandAll" @change="handleExpandAllChange" :disabled="addingRowId !== null">
        展开阶梯
      </el-checkbox>
		<el-button
		  v-if="$store.getters.hasPermission('system:pointPhrType:add')"
		  type="primary" 
		  size="mini" 
		  style="margin-left: 12px;"
		  @click="handleAddPhrType"
		  :disabled="addingRowId !== null"
		>
		  <i class="el-icon-plus"></i> 新增积分分类
		</el-button>
    </div>

    <!-- 数据表格区域 -->
    <div class="table-section" :class="{ 'blur-background': addingRowId !== null }">
      <!-- 遮罩层，用于添加状态下的半透明效果 -->
      <div v-if="addingRowId !== null" class="table-mask" @click="handleMaskClick"></div>
      
      <el-card class="table-card" :class="{ 'adding-mode': addingRowId !== null }">
        <el-table
          :data="tableData"
          style="width: 100%"
          height="calc(100vh - 320px)"
          @selection-change="handleSelectionChange"
          v-loading="loading"
          :row-key="getRowKey"
          :expand-row-keys="expandedRowKeys"
          @expand-change="handleExpandChange"
        >
          <el-table-column type="expand" width="55" align="center">
            <template #default="{ row }">
              <!-- 展开行内容 -->
              <div class="expand-content" v-if="row.list && row.list.length > 0" :class="{ 'adding-mode-expand': addingRowId === row.id }">
                <!-- 添加积分规则标题 -->
                <div v-if="addingRowId === row.id" class="add-rule-title">
                  <h4>为 {{ row.name }} 添加积分分类</h4>
                </div>
                
                <el-table
                  :data="row.list"
                  style="width: 100%"
                  size="mini"
                  :class="{ 'blur-table': addingRowId === row.id }"
                >
                  <el-table-column prop="clinicName" label="诊所名称" width="150" show-overflow-tooltip />
                  <el-table-column prop="createName" label="创建人名称" width="120" show-overflow-tooltip />
                  <el-table-column prop="createTime" label="创建时间" width="180" />
                  <el-table-column prop="pointPhrTypeName" label="积分健康档案人员分类名称" width="180" show-overflow-tooltip />
                  <el-table-column prop="pointPricStart" label="消费金额下限" width="120" align="center" />
                  <el-table-column prop="pointPricEnd" label="消费金额上限" width="120" align="center" />
                  <el-table-column prop="pointSalePric" label="生成1积分所需金额" width="150" align="center" />
                  <el-table-column prop="remark" label="备注" width="150" show-overflow-tooltip>
                    <template #default="{ row: rule }">
                      <span>{{ rule.remark || '无' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="150" fixed="right" align="center">
                    <template #default="{ row: rule }">
                      <el-switch
                        v-model="rule.state"
                        :active-value="1"
                        :inactive-value="0"
                        active-text="启用"
                        inactive-text="禁用"
                        :loading="rule.loading"
                        @change="(value) => handleRuleStateChange(rule, row, value)"
                        :disabled="addingRowId === row.id"
                      />
                      <el-button
                        v-if="$store.getters.hasPermission('system:points:edit')"
                        type="text"
                        size="mini"
                        @click="handleEditRule(row, rule)"
                        :disabled="addingRowId === row.id"
                      >
                        修改规则
                      </el-button>
                      <el-button
                        v-if="$store.getters.hasPermission('system:points:delete')"
                        type="text"
                        size="mini"
                        style="color: #f56c6c"
                        @click="handleDeleteRule(row, rule)"
                        :disabled="addingRowId === row.id"
                      >
                        删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                
                <!-- 新增积分规则行 -->
                <div v-if="addingRowId === row.id" class="new-rule-row">
                  <div class="new-rule-title">新增积分规则</div>
                  <el-table
                    :data="[newRule]"
                    style="width: 100%; margin-top: 10px"
                    size="mini"
                    class="new-rule-table"
                  >
                    <el-table-column prop="clinicName" label="诊所名称" width="150" show-overflow-tooltip>
                      <template #default>
                        <span>{{ row.clinicName || '当前诊所' }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="createName" label="创建人名称" width="120" show-overflow-tooltip>
                      <template #default>
                        <span>{{ userInfo.realName || '当前用户' }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="180">
                      <template #default>
                        <span>{{ currentTime }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="pointPhrTypeName" label="积分健康档案人员分类名称" width="180" show-overflow-tooltip>
                      <template #default>
                        <span>{{ row.name }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="消费金额下限" width="120" align="center">
                      <template #default>
                        <el-input-number
                          v-model="newRule.pointPricStart"
                          :min="0"
                          :precision="2"
                          :controls="false"
                          placeholder="请输入"
                          size="mini"
                          style="width: 100px"
                          @focus="handleInputFocus"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column label="消费金额上限" width="120" align="center">
                      <template #default>
                        <el-input-number
                          v-model="newRule.pointPricEnd"
                          :min="newRule.pointPricStart || 0"
                          :precision="2"
                          :controls="false"
                          placeholder="请输入"
                          size="mini"
                          style="width: 100px"
                          @focus="handleInputFocus"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column label="生成1积分所需金额" width="150" align="center">
                      <template #default>
                        <el-input-number
                          v-model="newRule.pointSalePric"
                          :min="0"
                          :precision="2"
                          :controls="false"
                          placeholder="请输入"
                          size="mini"
                          style="width: 100px"
                          @focus="handleInputFocus"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column label="备注" width="150" show-overflow-tooltip>
                      <template #default>
                        <el-input
                          v-model="newRule.remark"
                          placeholder="请输入备注"
                          size="mini"
                          style="width: 100%"
                          @focus="handleInputFocus"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="150" fixed="right" align="center">
                      <template #default>
                        <el-switch
                          v-model="newRule.state"
                          :active-value="1"
                          :inactive-value="0"
                          active-text="启用"
                          inactive-text="禁用"
                        />
                      </template>
                    </el-table-column>
                  </el-table>
                  
                  <!-- 新增行底部按钮 -->
                  <div class="new-rule-actions">
                    <el-button size="mini" @click="cancelAddRule">取消</el-button>
                    <el-button type="primary" size="mini" @click="confirmAddRule(row)" :loading="addingLoading">确认添加</el-button>
                  </div>
                </div>
              </div>
              <div v-else class="no-data">
                暂无积分规则
                <el-button
                  v-if="$store.getters.hasPermission('system:point:add')"
                  type="text"
                  size="mini"
                  @click="handleAddRuleInRow(row)"
                >
                  添加规则
                </el-button>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column type="selection" width="55" align="center" :selectable="rowSelectable" />
          <el-table-column prop="name" label="分类名称" min-width="150" show-overflow-tooltip />
          <el-table-column prop="birthPointNum" label="生日积分生成倍数" min-width="150" align="center">
            <template #default="{ row }">
              <span>{{ row.birthPointNum }}倍</span>
            </template>
          </el-table-column>
          <el-table-column prop="birthState" label="生日积分倍数是否生效" min-width="150" align="center">
            <template #default="{ row }">
              <span :style="{ color: row.birthState === 1 ? '#67C23A' : '#909399' }">
                {{ row.birthState === 1 ? '已生效' : '未生效' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="ruleState" label="积分规则状态是否生效" min-width="150" align="center">
            <template #default="{ row }">
              <span :style="{ color: row.ruleState === 1 ? '#67C23A' : '#909399' }">
                {{ row.ruleState === 1 ? '已生效' : '未生效' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="state" label="分类状态" width="100" align="center">
            <template #default="{ row }">
              <span :style="{ color: row.state === 1 ? '#67C23A' : '#909399' }">
                {{ row.state === 1 ? '启用' : '禁用' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="createName" label="创建人" min-width="120" show-overflow-tooltip />
          <el-table-column prop="createTime" label="创建时间" min-width="180" show-overflow-tooltip />
          <el-table-column label="操作" width="280" fixed="right" align="center">
            <template #default="{ row }">
              <el-button
                v-if="$store.getters.hasPermission('system:pointPhrType:edit')"
                type="text"
                size="small"
                @click="handleEditPhrType(row)"
                :disabled="addingRowId !== null"
              >
                <i class="el-icon-edit"></i> 修改
              </el-button>
              <el-button
                v-if="$store.getters.hasPermission('system:point:add')"
                type="text"
                size="small"
                @click="handleAddRuleInRow(row)"
                :disabled="addingRowId !== null"
              >
                <i class="el-icon-plus"></i> 添加积分规则
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>

    <!-- 添加/编辑/查看积分规则模态框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="60%"
      top="5vh"
      @close="handleDialogClose"
      ref="dialogRef"
    >
      <div ref="dialogContent">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="180px"
          :disabled="dialogType === 'view'"
        >
          <!-- 左右布局容器 -->
          <div class="two-column-layout">
            <!-- 左侧布局：一般设置 + 积分规则 -->
            <div class="left-column">
              <!-- 一般设置 -->
              <div class="form-section">
                <div class="section-title">一般设置</div>
                <el-form-item label="会员类型名称：" prop="memberTypeName">
                  <el-input
                    v-model="form.memberTypeName"
                    placeholder="请输入会员类型名称"
                    style="width: 100%"
                    :disabled="true"
                    size="mini"
                    value="积分"
                  />
                </el-form-item>
                
                <el-form-item label="状态：" prop="state" v-if="dialogType !== 'view'" label-width="180px">
                  <el-radio-group v-model="form.state">
                    <el-radio :label="1">可用</el-radio>
                    <el-radio :label="0">禁用</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="状态：" v-else label-width="180px">
                  <span>{{ form.state === 1 ? '可用' : '禁用' }}</span>
                </el-form-item>
              </div>

              <!-- 积分规则 -->
              <div class="form-section">
                <div class="section-title">积分规则</div>
                
                <!-- 固定积分改为生成1积分所需金额 -->
                <el-form-item label="生成1积分所需金额：" prop="pointSalePric" required>
                  <el-input-number
                    v-model="form.pointSalePric"
                    :min="0"
                    :precision="2"
                    :controls="false"
                    placeholder="请输入生成1积分所需金额"
                    size="mini"
                    style="width: 120px; margin-right: 8px"
                  />
                  <span>元</span>
                </el-form-item>
                
                <!-- 积分健康档案人员分类 -->
                <el-form-item label="积分健康档案人员分类：" prop="pointPhrTypeId" required>
                  <el-select
                    v-model="form.pointPhrTypeId"
                    placeholder="请选择积分健康档案人员分类"
                    style="width: 100%"
                    filterable
                    clearable
                    size="mini"
                    :disabled="dialogType === 'view'"
                    @change="handlePhrTypeChange"
                  >
                    <el-option
                      v-for="item in phrTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                
                <!-- 备注 -->
                <el-form-item label="备注：" prop="remark">
                  <el-input
                    v-model="form.remark"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入备注"
                    maxlength="200"
                    show-word-limit
                    size="mini"
                    :disabled="dialogType === 'view'"
                  />
                </el-form-item>
              </div>
            </div>

            <!-- 右侧布局：阶梯固定积分 -->
            <div class="right-column">
              <!-- 阶梯固定积分 -->
              <div class="form-section">
                <div class="section-title">阶梯固定积分</div>
                
                <div class="ladder-points-container" :style="{ maxHeight: '300px', overflowY: 'auto' }">
                  <div v-for="(ladder, index) in form.ladderPoints" :key="index" class="ladder-item">
                    <div class="ladder-header">
                      <div class="ladder-controls">
                        <!-- 左侧减号图标（删除） -->
                        <el-button
                          v-if="form.ladderPoints.length > 1 && dialogType !== 'view'"
                          type="text"
                          size="mini"
                          class="delete-btn"
                          @click="removeLadder(index)"
                        >
                          <i class="el-icon-minus"></i>
                        </el-button>
                        <span>阶梯{{ index + 1 }}</span>
                      </div>
                    </div>
                    <div class="ladder-content">
                      <span>消费</span>
                      <el-input-number
                        v-model="ladder.start"
                        :min="0"
                        :precision="2"
                        :controls="false"
                        placeholder="下限"
                        size="mini"
                        style="width: 100px; margin: 0 4px"
                        :disabled="dialogType === 'view'"
                      />
                      <span>~</span>
                      <el-input-number
                        v-model="ladder.end"
                        :min="ladder.start || 0"
                        :precision="2"
                        :controls="false"
                        placeholder="上限"
                        size="mini"
                        style="width: 100px; margin: 0 4px"
                        :disabled="dialogType === 'view'"
                      />
                      <span style="margin: 0 4px; font-size: 12px">元</span>
                      <!-- 右侧开关 -->
                      <el-switch
                        v-model="ladder.state"
                        :active-value="1"
                        :inactive-value="0"
                        active-text=""
                        inactive-text=""
                        style="margin-left: 10px"
                        :loading="ladder.loading"
                        @change="(value) => handleLadderStateChange(ladder, value)"
                        :disabled="dialogType === 'view'"
                      />
                    </div>
                  </div>
                  <el-button
                    v-if="dialogType !== 'view'"
                    type="text"
                    size="mini"
                    @click="addLadder"
                    style="margin-top: 10px"
                  >
                    <i class="el-icon-plus"></i> 添加阶梯
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button v-if="dialogType !== 'view'" size="mini" @click="dialogVisible = false">取消</el-button>
        <el-button v-if="dialogType === 'view'" size="mini" @click="dialogVisible = false">关闭</el-button>
        <el-button v-if="dialogType !== 'view'" size="mini" type="primary" @click="handleSubmit" :loading="submitLoading">
          确定
        </el-button>
      </div>
    </el-dialog>

    <!-- 新增健康档案人员积分分类模态框 -->
    <el-dialog
      title="新增健康档案人员积分分类"
      :visible.sync="phrTypeDialogVisible"
      width="500px"
      @close="handlePhrTypeDialogClose"
    >
      <el-form
        ref="phrTypeForm"
        :model="phrTypeForm"
        :rules="phrTypeRules"
        label-width="120px"
      >
        <el-form-item label="分类名称：" prop="name" required>
          <el-input
            v-model="phrTypeForm.name"
            placeholder="请输入分类名称"
            style="width: 100%"
            size="mini"
          />
        </el-form-item>
        
        <el-form-item label="生日积分生成倍数：" prop="birthPointNum">
          <el-input-number
            v-model="phrTypeForm.birthPointNum"
            :min="0"
            :precision="2"
            :controls="false"
            placeholder="请输入生日积分生成倍数"
            size="mini"
            style="width: 120px; margin-right: 8px"
          />
          <span>倍</span>
        </el-form-item>
        
        <el-form-item label="生日积分倍数生效：" prop="birthState">
          <el-switch
            v-model="phrTypeForm.birthState"
            :active-value="1"
            :inactive-value="0"
            active-text="是"
            inactive-text="否"
          />
        </el-form-item>
        
        <el-form-item label="积分规则状态生效：" prop="ruleState">
          <el-switch
            v-model="phrTypeForm.ruleState"
            :active-value="1"
            :inactive-value="0"
            active-text="是"
            inactive-text="否"
          />
        </el-form-item>
		<el-form-item label="状态生效：" prop="state">
		  <el-switch
		    v-model="phrTypeForm.state"
		    :active-value="1"
		    :inactive-value="0"
		    active-text="启用"
		    inactive-text="禁用"
		  />
		</el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="phrTypeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleAddPhrTypeForm" :loading="phrTypeLoading">
          确定
        </el-button>
      </div>
    </el-dialog>

    <!-- 修改积分分类模态框 -->
    <el-dialog
      :title="`修改${editPhrTypeForm.name}的积分分类`"
      :visible.sync="editPhrTypeDialogVisible"
      width="500px"
      @close="handleEditPhrTypeDialogClose"
    >
      <el-form
        ref="editPhrTypeFormRef"
        :model="editPhrTypeForm"
        :rules="editPhrTypeRules"
        label-width="120px"
      >
        <el-form-item label="分类名称：" prop="name" required>
          <el-input
            v-model="editPhrTypeForm.name"
            placeholder="请输入分类名称"
            style="width: 100%"
            size="mini"
          />
        </el-form-item>
        
        <el-form-item label="生日积分生成倍数：" prop="birthPointNum">
          <el-input-number
            v-model="editPhrTypeForm.birthPointNum"
            :min="0"
            :precision="2"
            :controls="false"
            placeholder="请输入生日积分生成倍数"
            size="mini"
            style="width: 120px; margin-right: 8px"
          />
          <span>倍</span>
        </el-form-item>
        
        <el-form-item label="生日积分倍数生效：" prop="birthState">
          <el-switch
            v-model="editPhrTypeForm.birthState"
            :active-value="1"
            :inactive-value="0"
            active-text="是"
            inactive-text="否"
          />
        </el-form-item>
        
        <el-form-item label="积分规则状态生效：" prop="ruleState">
          <el-switch
            v-model="editPhrTypeForm.ruleState"
            :active-value="1"
            :inactive-value="0"
            active-text="是"
            inactive-text="否"
          />
        </el-form-item>
		<el-form-item label="状态生效：" prop="state">
		  <el-switch
		    v-model="editPhrTypeForm.state"
		    :active-value="1"
		    :inactive-value="0"
		    active-text="启用"
		    inactive-text="禁用"
		  />
		</el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="editPhrTypeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmitEditPhrType" :loading="editPhrTypeLoading">确认修改</el-button>
      </div>
    </el-dialog>
    
    <!-- 离开确认对话框 -->
    <el-dialog
      title="提示"
      :visible.sync="leaveConfirmVisible"
      width="400px"
    >
      <span>当前新增的积分分类规则还未生效，是否离开？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="leaveConfirmVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmLeave">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { updatePointsRule, deleteRule, addPointsRule, editPoints, pointsRuleDetails } from "@/api/points.js";
import { listAll, listSelectAll, addPhrType, editPhrType, deletePhrType, getPointsDetails } from "@/api/points.js";

export default {
  name: 'PointsPage',
  data() {
    return {
      // 查询参数
      queryParams: {},
      
      // 表格数据
      tableData: [],
      
      // 加载状态
      loading: false,
      
      // 选中行
      selectedRows: [],
      
      // 展开的行keys
      expandedRowKeys: [],
      
      // 展开所有控制
      expandAll: true,
      
      // 当前时间
      currentTime: new Date().toLocaleString(),
      
      // 添加状态
      addingRowId: null, // 正在添加规则的行id
      addingLoading: false, // 添加规则加载状态
      
      // 新增规则表单
      newRule: {
        pointPricStart: null,
        pointPricEnd: null,
        pointSalePric: null,
        remark: '',
        state: 1
      },
      
      // 离开确认对话框
      leaveConfirmVisible: false,
      inputFocused: false, // 记录输入框是否获得焦点
      
      // 对话框相关
      dialogVisible: false,
      dialogTitle: '添加积分生成规则',
      dialogType: 'add', // 'add' 或 'edit' 或 'view'
      currentPhrType: null, // 当前操作的健康档案人员分类
      
      // 健康档案人员分类模态框
      phrTypeDialogVisible: false,
      phrTypeLoading: false,
      
      // 修改积分分类模态框
      editPhrTypeDialogVisible: false,
      editPhrTypeLoading: false,
      
      // 健康档案人员分类表单
      phrTypeForm: {
        id: null,
        name: '',
		state: 0,
        birthPointNum: 0,
        birthState: 0,
        ruleState: 0
      },
      
      // 修改积分分类表单
      editPhrTypeForm: {
        id: null,
        name: '',
        state: 0,
        birthPointNum: 0,
        birthState: 0,
        ruleState: 0
      },
      
      // 健康档案人员分类验证规则
      phrTypeRules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' },
          { min: 1, max: 50, message: '名称长度在1到50个字符', trigger: 'blur' }
        ],
        birthPointNum: [
          { type: 'number', min: 0, message: '生日积分生成倍数不能为负数', trigger: 'blur' }
        ]
      },
      
      // 修改积分分类验证规则
      editPhrTypeRules: {
        name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' },
          { min: 1, max: 50, message: '名称长度在1到50个字符', trigger: 'blur' }
        ],
        birthPointNum: [
          { type: 'number', min: 0, message: '生日积分生成倍数不能为负数', trigger: 'blur' }
        ]
      },
      
      // 健康档案人员分类选项
      phrTypeOptions: [],
      
      // 积分规则表单数据
      form: {
        id: null,
        // 一般设置
        memberTypeName: '积分',
        
        // 积分规则
        pointSalePric: 10, // 生成1积分所需金额
        ladderPoints: [
          {
            start: 1,    // 消费金额下限
            end: 10,     // 消费金额上限
            state: 1,    // 阶梯状态
            loading: false
          }
        ],
        
        // 健康档案人员分类
        pointPhrTypeId: null,
        
        // 备注和状态
        remark: '',
        state: 1
      },
      
      // 表单原始数据（用于编辑时对比是否有修改）
      originalForm: {},
      
      // 表单验证规则
      rules: {
        pointSalePric: [
          { required: true, message: '请输入生成1积分所需金额', trigger: 'blur' },
          { type: 'number', min: 0, message: '生成1积分所需金额不能为负数', trigger: 'blur' }
        ],
        pointPhrTypeId: [
          { required: true, message: '请选择积分健康档案人员分类', trigger: 'change' }
        ],
        state: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      },
      
      // 提交加载状态
      submitLoading: false,
      
      // 用户信息
      userInfo: {},
      
      // 诊所列表
      clinicList: [
        { clinicId: 1, clinicName: '北京诊所' },
        { clinicId: 2, clinicName: '上海诊所' },
        { clinicId: 3, clinicName: '广州诊所' }
      ],
      
      // 记录正在更新的行
      updatingRows: new Set()
    };
  },
  computed: {
    // 当前用户的诊所ID
    currentClinicId() {
      return this.userInfo.clinicId || null;
    },
    
    // 当前用户的诊所名称
    currentClinicName() {
      if (!this.currentClinicId) return '';
      const clinic = this.clinicList.find(item => item.clinicId === this.currentClinicId);
      return clinic ? clinic.clinicName : `诊所${this.currentClinicId}`;
    }
  },
  methods: {
    // 获取行的唯一key
    getRowKey(row) {
      return row.id;
    },
    
    // 展开行变化
    handleExpandChange(row, expandedRows) {
      this.expandedRowKeys = expandedRows.map(item => item.id);
      // 如果行被展开，处理list中的数据，添加loading状态
      if (expandedRows.length > 0) {
        expandedRows.forEach(row => {
          if (row.list && row.list.length > 0) {
            row.list = row.list.map(rule => ({
              ...rule,
              loading: false
            }));
          }
        });
      }
    },
    
    // 展开全部切换
    handleExpandAllChange(value) {
      if (value) {
        // 展开所有行
        this.expandedRowKeys = this.tableData.map(item => item.id);
      } else {
        // 收起所有行
        this.expandedRowKeys = [];
      }
    },
    
    // 检查行是否可选
    rowSelectable(row) {
      return this.addingRowId === null;
    },
    
    // 获取表格数据
    async fetchData() {
      this.loading = true;
      try {
        const response = await listAll();
        
        if (response && response.code === 200) {
          const data = response.data || [];
          
          // 处理表格数据，添加loading状态
          this.tableData = data.map(item => {
            return {
              ...item,
              birthStateLoading: false,
              ruleStateLoading: false,
              loading: false
            };
          });
          
          // 如果expandAll为true，展开所有行
          if (this.expandAll) {
            this.expandedRowKeys = this.tableData.map(item => item.id);
          }
        } else {
          this.$message.error(response?.message || '获取数据失败');
        }
      } catch (error) {
        console.error('获取积分分类数据失败:', error);
        this.$message.error('获取数据失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    
    // 获取健康档案人员分类选项
    async fetchPhrTypeOptions() {
      try {
        const response = await listSelectAll();
        if (response && response.code === 200) {
          this.phrTypeOptions = response.data.map(item => ({
            value: item.id,
            label: item.name
          }));
        } else {
          this.$message.error(response?.message || '获取分类数据失败');
        }
      } catch (error) {
        console.error('获取健康档案人员分类失败:', error);
        this.$message.error('获取分类数据失败');
      }
    },
    
    // 表格选中行变化
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    
    // 添加健康档案人员分类
    handleAddPhrType() {
      this.phrTypeDialogVisible = true;
      this.phrTypeForm = {
        id: null,
        name: '',
        state: 0,
        birthPointNum: 0,
        birthState: 0,
        ruleState: 0
      };
    },
    
    // 编辑健康档案人员分类
    async handleEditPhrType(row) {
      try {
        this.loading = true;
        const response = await getPointsDetails({ id: row.id });
        
        if (response && response.code === 200) {
          const data = response.data || {};
          
          this.editPhrTypeForm = {
            id: data.id,
            name: data.name || '',
            state: data.state || 0,
            birthPointNum: data.birthPointNum || 0,
            birthState: data.birthState || 0,
            ruleState: data.ruleState || 0
          };
          
          this.editPhrTypeDialogVisible = true;
          
          // 清空验证
          this.$nextTick(() => {
            if (this.$refs.editPhrTypeFormRef) {
              this.$refs.editPhrTypeFormRef.clearValidate();
            }
          });
        } else {
          this.$message.error(response?.message || '获取详情失败');
        }
      } catch (error) {
        console.error('获取积分分类详情失败:', error);
        this.$message.error('获取详情失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    
    // 提交修改积分分类表单
    async handleSubmitEditPhrType() {
      this.$refs.editPhrTypeFormRef.validate(async (valid) => {
        if (valid) {
          this.editPhrTypeLoading = true;
          try {
            const response = await editPoints(this.editPhrTypeForm);
            
            if (response && response.code === 200) {
              this.$message.success('修改成功');
              this.editPhrTypeDialogVisible = false;
              this.fetchData();
            } else {
              this.$message.error(response?.message || '修改失败');
            }
          } catch (error) {
            console.error('修改失败:', error);
            this.$message.error('修改失败，请稍后重试');
          } finally {
            this.editPhrTypeLoading = false;
          }
        } else {
          this.$message.warning('请将必填信息填写完整');
          return false;
        }
      });
    },
    
    // 修改积分分类对话框关闭
    handleEditPhrTypeDialogClose() {
      if (this.$refs.editPhrTypeFormRef) {
        this.$refs.editPhrTypeFormRef.clearValidate();
      }
      this.editPhrTypeForm = {
        id: null,
        name: '',
        state: 0,
        birthPointNum: 0,
        birthState: 0,
        ruleState: 0
      };
    },
    
    // 在表格行中添加积分规则
    handleAddRuleInRow(row) {
      // 设置当前时间为最新
      this.currentTime = new Date().toLocaleString();
      
      // 展开当前行
      if (!this.expandedRowKeys.includes(row.id)) {
        this.expandedRowKeys.push(row.id);
      }
      
      // 设置添加状态
      this.addingRowId = row.id;
      
      // 初始化新增规则
      this.newRule = {
        pointPricStart: null,
        pointPricEnd: null,
        pointSalePric: null,
        remark: '',
        state: 1
      };
      
      // 添加点击外部事件监听
      this.addOutsideClickHandler();
    },
    
    // 处理输入框获得焦点
    handleInputFocus() {
      this.inputFocused = true;
    },
    
    // 处理遮罩层点击
    handleMaskClick() {
      // 如果输入框获得焦点，则不显示离开确认
      if (!this.inputFocused) {
        this.leaveConfirmVisible = true;
      }
      this.inputFocused = false;
    },
    
    // 添加点击外部事件处理
    addOutsideClickHandler() {
      // 延迟添加事件监听，避免立即触发
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick);
      }, 100);
    },
    
    // 移除点击外部事件处理
    removeOutsideClickHandler() {
      document.removeEventListener('click', this.handleOutsideClick);
    },
    
    // 处理外部点击
    handleOutsideClick(event) {
      // 检查点击是否在新增规则区域内
      const newRuleRow = document.querySelector('.new-rule-row');
      const actionButtons = document.querySelectorAll('.el-button--text');
      
      let isInsideNewRule = false;
      
      if (newRuleRow) {
        isInsideNewRule = newRuleRow.contains(event.target);
      }
      
      // 检查是否点击了操作按钮
      let isActionButton = false;
      actionButtons.forEach(button => {
        if (button.contains(event.target)) {
          isActionButton = true;
        }
      });
      
      // 如果点击了外部区域，且不是操作按钮，显示离开确认
      if (!isInsideNewRule && !isActionButton && this.addingRowId !== null) {
        this.leaveConfirmVisible = true;
      }
    },
    
    // 确认离开
    confirmLeave() {
      this.cancelAddRule();
      this.leaveConfirmVisible = false;
    },
    
    // 取消添加规则
    cancelAddRule() {
      this.addingRowId = null;
      this.newRule = {
        pointPricStart: null,
        pointPricEnd: null,
        pointSalePric: null,
        remark: '',
        state: 1
      };
      this.removeOutsideClickHandler();
    },
    
    // 确认添加规则
    async confirmAddRule(row) {
      // 验证必填字段
      if (!this.newRule.pointPricStart && this.newRule.pointPricStart !== 0) {
        this.$message.warning('请输入消费金额下限');
        return;
      }
      
      if (!this.newRule.pointPricEnd && this.newRule.pointPricEnd !== 0) {
        this.$message.warning('请输入消费金额上限');
        return;
      }
      
      if (!this.newRule.pointSalePric && this.newRule.pointSalePric !== 0) {
        this.$message.warning('请输入生成1积分所需金额');
        return;
      }
      
      if (this.newRule.pointPricEnd <= this.newRule.pointPricStart) {
        this.$message.warning('消费金额上限必须大于下限');
        return;
      }
      
      this.addingLoading = true;
      try {
        const submitData = {
          pointPhrTypeId: row.id,
          pointPricStart: this.newRule.pointPricStart,
          pointPricEnd: this.newRule.pointPricEnd,
          pointSalePric: this.newRule.pointSalePric,
          remark: this.newRule.remark,
          state: this.newRule.state
        };
        
        const response = await addPointsRule(submitData);
        
        if (response && response.code === 200) {
          this.$message.success(`已为${row.name}添加的积分规则！`);
          this.cancelAddRule();
          this.fetchData();
        } else {
          this.$message.error(response?.message || '添加失败');
        }
      } catch (error) {
        console.error('添加积分规则失败:', error);
        this.$message.error('添加失败，请稍后重试');
      } finally {
        this.addingLoading = false;
      }
    },
    
    // 编辑积分规则
    async handleEditRule(row, rule = null) {
      this.currentPhrType = row;
      
      if (rule) {
        // 从展开行编辑规则
        this.dialogType = 'edit';
        this.dialogTitle = '修改积分规则';
        
        try {
          this.loading = true;
          const response = await pointsRuleDetails({ id: rule.id });
          
          if (response && response.code === 200) {
            const data = response.data || {};
            
            this.form = {
              id: data.id,
              memberTypeName: '积分',
              pointSalePric: data.pointSalePric || 10,
              ladderPoints: data.ladderPoints || [
                {
                  start: data.pointPricStart || 1,
                  end: data.pointPricEnd || 10,
                  state: data.state || 1,
                  loading: false
                }
              ],
              pointPhrTypeId: data.pointPhrTypeId || null,
              remark: data.remark || '',
              state: data.state
            };
            
            this.originalForm = JSON.parse(JSON.stringify(this.form));
            this.dialogVisible = true;
            this.fetchPhrTypeOptions();
          }
        } catch (error) {
          console.error('获取积分详情失败:', error);
          this.$message.error('获取详情失败，请稍后重试');
        } finally {
          this.loading = false;
        }
      } else {
        // 从分类行编辑规则（需要先展开查看规则列表）
        this.$message.info('请先展开查看该分类的积分规则列表');
      }
    },
    
    // 删除单条记录
    handleDelete(row) {
      this.$confirm('确定要删除这条记录吗？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async () => {
        try {
          const response = await deletePhrType({ ids: row.id });
          
          if (response && response.code === 200) {
            this.$message.success('删除成功');
            this.fetchData();
          } else {
            this.$message.error(response?.message || '删除失败');
          }
        } catch (error) {
          console.error('删除失败:', error);
          this.$message.error('删除失败，请稍后重试');
        }
      }).catch(() => {});
    },
    
    // 删除积分规则
    handleDeleteRule(phrType, rule) {
      this.$confirm('确定要删除这条积分规则吗？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async () => {
        try {
          const response = await deleteRule({ id: rule.id });
          
          if (response && response.code === 200) {
            this.$message.success('删除成功');
            // 重新加载数据
            this.fetchData();
          } else {
            this.$message.error(response?.message || '删除失败');
          }
        } catch (error) {
          console.error('删除失败:', error);
          this.$message.error('删除失败，请稍后重试');
        }
      }).catch(() => {});
    },
    
    // 积分规则状态切换（展开行中的）
    async handleRuleStateChange(rule, phrType, newState) {
      rule.loading = true;
      
      try {
        const response = await updatePointsRule({
          id: rule.id,
          state: newState
        });
        
        if (response && response.code === 200) {
          this.$message.success(newState === 1 ? '积分规则已启用' : '积分规则已禁用');
          rule.state = newState;
        } else {
          rule.state = rule.state === 1 ? 0 : 1;
          this.$message.error(response?.message || '状态更新失败');
        }
      } catch (error) {
        console.error('积分规则状态更新失败:', error);
        rule.state = rule.state === 1 ? 0 : 1;
        this.$message.error('状态更新失败，请稍后重试');
      } finally {
        rule.loading = false;
      }
    },
    
    // 阶梯状态切换
    async handleLadderStateChange(ladder, newState) {
      ladder.loading = true;
      
      try {
        // 这里假设有更新阶梯状态的接口
        // 实际情况中可能需要调用updatePointsRule接口
        this.$message.success(`已${newState === 1 ? '启用' : '禁用'}阶梯规则`);
        ladder.state = newState;
      } catch (error) {
        console.error('阶梯状态更新失败:', error);
        ladder.state = ladder.state === 1 ? 0 : 1;
        this.$message.error('状态更新失败，请稍后重试');
      } finally {
        ladder.loading = false;
      }
    },
    
    // 添加阶梯
    addLadder() {
      this.form.ladderPoints.push({
        start: 1,
        end: 10,
        state: 1,
        loading: false
      });
    },
    
    // 删除阶梯
    removeLadder(index) {
      if (this.form.ladderPoints.length > 1) {
        this.form.ladderPoints.splice(index, 1);
      } else {
        this.$message.warning('至少保留一个阶梯规则');
      }
    },
    
    // 健康档案人员分类模态框关闭
    handlePhrTypeDialogClose() {
      this.$refs.phrTypeForm.clearValidate();
    },
    
    // 新增健康档案人员分类
    async handleAddPhrTypeForm() {
      this.$refs.phrTypeForm.validate(async (valid) => {
        if (valid) {
          this.phrTypeLoading = true;
          try {
            let response;
            
            if (this.phrTypeForm.id) {
              // 编辑操作
              response = await editPhrType(this.phrTypeForm);
            } else {
              // 添加操作
              response = await addPhrType(this.phrTypeForm);
            }
            
            if (response && response.code === 200) {
              this.$message.success(this.phrTypeForm.id ? '修改成功' : '新增成功');
              this.phrTypeDialogVisible = false;
              this.fetchData();
            } else {
              this.$message.error(response?.message || '操作失败');
            }
          } catch (error) {
            console.error('操作失败:', error);
            this.$message.error('操作失败，请稍后重试');
          } finally {
            this.phrTypeLoading = false;
          }
        }
      });
    },
    
    // 健康档案人员分类选择变化
    handlePhrTypeChange(value) {
      console.log('选择的分类ID:', value);
    },
    
    // 积分规则表单提交
    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // 验证阶梯规则
          for (let i = 0; i < this.form.ladderPoints.length; i++) {
            const ladder = this.form.ladderPoints[i];
            if (!ladder.start && ladder.start !== 0) {
              this.$message.warning(`请输入第${i + 1}个阶梯的消费金额下限`);
              return;
            }
            if (!ladder.end && ladder.end !== 0) {
              this.$message.warning(`请输入第${i + 1}个阶梯的消费金额上限`);
              return;
            }
            if (ladder.end <= ladder.start) {
              this.$message.warning(`第${i + 1}个阶梯的消费金额上限必须大于下限`);
              return;
            }
          }
          
          // 如果是编辑模式，检查是否有修改
          if (this.dialogType === 'edit') {
            const hasChanges = JSON.stringify(this.form) !== JSON.stringify(this.originalForm);
            
            if (!hasChanges) {
              this.$message.warning('当前操作未做出任何修改变动，请重试！');
              return;
            }
          }
          
          this.submitLoading = true;
          try {
            let response;
            
            // 准备提交数据
            const submitData = {
              pointPhrTypeId: this.form.pointPhrTypeId,
              pointPricStart: this.form.ladderPoints[0].start,
              pointPricEnd: this.form.ladderPoints[0].end,
              pointSalePric: this.form.pointSalePric,
              state: this.form.state,
              remark: this.form.remark
            };
            
            if (this.dialogType === 'add') {
              response = await addPointsRule(submitData);
            } else {
              submitData.id = this.form.id;
              response = await editPoints(submitData);
            }
            
            if (response && response.code === 200) {
              this.$message.success(this.dialogType === 'add' ? '新增成功' : '修改成功');
              this.dialogVisible = false;
              
              // 重新加载数据
              this.fetchData();
            } else {
              this.$message.error(response?.message || '操作失败');
            }
          } catch (error) {
            console.error('操作失败:', error);
            this.$message.error('操作失败，请稍后重试');
          } finally {
            this.submitLoading = false;
          }
        } else {
          this.$message.warning('请将必填信息填写完整！');
          return false;
        }
      });
    },
    
    // 对话框关闭
    handleDialogClose() {
      this.$refs.form.clearValidate();
    }
  },
  mounted() {
    // 从本地存储获取用户信息
    try {
      const userInfoStr = localStorage.getItem('userInfo');
      if (userInfoStr) {
        this.userInfo = JSON.parse(userInfoStr);
      }
    } catch (error) {
      console.error('获取用户信息失败:', error);
    }
    
    // 组件挂载时获取数据
    this.fetchData();
  },
  beforeDestroy() {
    // 移除事件监听
    this.removeOutsideClickHandler();
  }
};
</script>

<style lang="less" scoped>
.points-container {
  height: calc(100vh - 180px);
  padding: 16px;
  box-sizing: border-box;
  background-color: #f0f2f5;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  ::v-deep .el-dialog__body{
    padding: 20px;
  }
  .header {
    margin-bottom: 16px;
    
    h2 {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
      color: #333;
    }
  }

  .action-section {
    margin-bottom: 16px;
    
    .el-button {
      margin-right: 10px;
      
      &:last-child {
        margin-right: 0;
      }
    }
  }

  .expand-control {
    margin-bottom: 16px;
    padding: 8px 16px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .table-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    position: relative;
    
    &.blur-background {
      .table-mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255, 255, 255, 0.7);
        z-index: 1000;
        pointer-events: auto;
      }
      
      .table-card {
        &.adding-mode {
          z-index: 1001;
          position: relative;
          
          .expand-content {
            &.adding-mode-expand {
              z-index: 1002;
              
              .add-rule-title {
                z-index: 1003;
              }
              
              .new-rule-row {
                z-index: 1004;
              }
            }
            
            .blur-table {
              filter: blur(3px);
              opacity: 0.7;
              pointer-events: none;
            }
          }
        }
      }
    }
    
    .table-card {
      flex: 1;
      display: flex;
      flex-direction: column;
      
      :deep(.el-card__body) {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 20px;
      }
    }
    
    .expand-content {
      padding: 10px;
      background-color: #f8f9fa;
      border-radius: 4px;
      margin: 5px 0;
      position: relative;
      
      .add-rule-title {
        margin-bottom: 15px;
        padding-bottom: 10px;
        border-bottom: 1px solid #ebeef5;
        position: relative;
        z-index: 1;
        
        h4 {
          margin: 0;
          color: #409EFF;
          font-size: 16px;
        }
      }
      
      .new-rule-row {
        margin-top: 20px;
        padding: 15px;
        background-color: #fff;
        border: 1px solid #e1f5fe;
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
        position: relative;
        z-index: 1;
        
        .new-rule-title {
          font-weight: 600;
          color: #409EFF;
          margin-bottom: 10px;
          font-size: 14px;
        }
        
        .new-rule-table {
          background-color: #f8fdff;
          
          :deep(.el-table__row) {
            background-color: #f8fdff;
          }
        }
        
        .new-rule-actions {
          margin-top: 15px;
          text-align: left;
          padding-top: 15px;
          border-top: 1px solid #e1f5fe;
          
          .el-button {
            margin-left: 10px;
          }
        }
      }
      
      .no-data {
        text-align: center;
        padding: 20px;
        color: #999;
      }
    }
  }
}

// 模态框相关样式
.dialog-title-tip {
  position: absolute;
  left: 166px;
  top: 25px;
  
  .el-icon-question {
    color: #409eff;
    cursor: pointer;
    font-size: 18px;
    
    &:hover {
      color: #66b1ff;
    }
  }
}

// 左右布局容器
.two-column-layout {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  
  .left-column,
  .right-column {
    flex: 1;
    min-width: 0; // 防止内容溢出
  }
}

// 底部全宽区域
.full-width-section {
  width: 100%;
}

.form-section {
  margin-bottom: 20px;
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 4px;
  
  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e8e8e8;
  }
  
  .unit-text {
    margin-left: 8px;
    color: #666;
  }
  
  .degrade-to-text {
    margin-left: 16px;
    margin-right: 8px;
    color: #666;
  }
  
  .form-tip {
    font-size: 12px;
    color: #999;
    margin-top: 4px;
  }
}

.ladder-points-container {
  .ladder-item {
    margin-bottom: 12px;
    padding: 10px;
    background-color: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    
    .ladder-header {
      font-weight: 500;
      margin-bottom: 6px;
      color: #333;
      font-size: 14px;
      
      .ladder-controls {
        display: flex;
        align-items: center;
        
        .delete-btn {
          color: #f56c6c;
          margin-right: 8px;
          padding: 0;
          
          i {
            font-size: 16px;
          }
        }
      }
    }
    
    .ladder-content {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
  }
}

// 响应式适配
@media (max-width: 768px) {
  .points-container {
    padding: 12px;
    
    .header h2 {
      font-size: 18px;
    }
    
    .form-buttons {
      .el-form-item {
        .el-button {
          width: 100%;
          margin-bottom: 8px;
          
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    
    .table-section .table-card :deep(.el-card__body) {
      padding: 16px;
    }
    
    .two-column-layout {
      flex-direction: column;
      gap: 15px;
    }
    
    .ladder-content {
      flex-wrap: wrap;
      
      > * {
        margin-bottom: 8px;
      }
    }
  }
}

@media (max-width: 576px) {
  .points-container {
    .action-section .el-button {
      margin-bottom: 8px;
      width: 100%;
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>